import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import stylesData from './assets/style_data.json'

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App style_data={stylesData}/>
  </React.StrictMode>
);
